export default __webpack_public_path__ + "static/media/pic-center.2f057867.svg";